import React from "react";
import { useParams ,Link} from "react-router-dom";
import projectsData from "../Data/projectsData";
import "../Styles/Projects.css";

const ProjectDetail = () => {
  const { id } = useParams();
  const project = projectsData.find(p => p.id === id);

  if (!project) return <h2>Project Not Found</h2>;

  return (
    <section className="project-detail-page">

      {/* Top Banner */}
      <div className="detail-banner">
        <img src={project.image} alt={project.title} />
      </div>

      {/* Breadcrumb */}
      {/* <div className="breadcrumb">
        <span>Our Esteemed Project</span>
      </div> */}

      <div className="detail-container">

        {/* Title Box */}
        <div className="detail-title-box">
          <h1>{project.titles}</h1>
        </div>

        {/* Description */}
        <div className="detail-description">
          <p>{project.description}</p>
        </div>

        {/* Info Grid */}
        <div className="detail-info-grid">

          {/* <div className="info-box">
            <strong>State/UT :</strong> {project.location}
          </div> */}

          {/* <div className="info-box">
            <strong>Appointment Date :</strong> {project.date}
          </div> */}

          {/* <div className="info-box">
            <strong>Project Cost :</strong> {project.cost}
          </div> */}

          {/* <div className="info-box">
            <strong>Commissioned Under :</strong> {project.authority}
          </div> */}

        </div>

      </div>

      {/* Bottom Banner Section */}
        <div className="bottom-banner">
          <img
            src={
              project.category === "ongoing"
                ? "/projects/ongoing-demo.jpg"
                : "/projects/ongoing-demo.jpg"
            }
            alt="banner"
          />

          <div className="bottom-banner-content">
           
            <p>
              {project.category === "ongoing"
                ? "Driving progress with excellence and innovation."
                : "Delivering quality infrastructure with trust and commitment."}
            </p> <br />
            <Link to="/projects"><button className="banner-btn">
              {project.category === "ongoing"
                ? "Ongoing Projects"
                : "Completed Projects"}
            </button></Link>

          </div>
        </div>


    </section>
  );
};

export default ProjectDetail;
